module.exports = {
    "breadcrumbs": `Breadcrumb`
};


//# sourceMappingURL=it-IT.main.js.map
